import React, { useState, useEffect, useRef, useContext } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { isNil } from "lodash";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import moment from "moment";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  DialogActions,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Switch,
  FormControlLabel,
  Grid,
  Divider,
  Tab,
  Tabs,
  Paper,
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Tooltip,
} from "@material-ui/core";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import QueueSelect from "../QueueSelect";
import TabPanel from "../TabPanel";
import { Autorenew, FileCopy, ExpandMore } from "@material-ui/icons";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import SchedulesForm from "../SchedulesForm";
import usePlanPermissions from "../../hooks/usePlanPermissions";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Colorize } from "@material-ui/icons";
import ColorPicker from "../ColorPicker";
import InputAdornment from "@material-ui/core/InputAdornment";
import getRandomHexColor from "../../utils/getRandomHexColor";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    gap: 4,
  },

  multFieldLine: {
    marginTop: 12,
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      "& > *:not(:last-child)": {
        marginRight: 0,
        marginBottom: theme.spacing(1),
      },
    },
  },

  btnWrapper: {
    position: "relative",
  },
  importMessage: {
    marginTop: 12,
    marginBottom: 12,
    paddingBottom: 20,
    paddingTop: 15,
    padding: 15,
    border: "1px solid #e0e0e0",
    borderRadius: 8,
    backgroundColor: "#f9f9f9",
    display: "flex",
    flexDirection: "column",
    gap: 12,
    [theme.breakpoints.down("sm")]: {
      padding: 12,
    },
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },

  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
      marginBottom: theme.spacing(1),
    },
  },
  tokenRefresh: {
    minWidth: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px",
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      marginTop: theme.spacing(1),
    },
  },
  colorAdorment: {
    width: 20,
    height: 20,
    borderRadius: "50%",
  },
  formControl: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  colorField: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  sectionTitle: {
    fontWeight: "bold",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    color: "#333",
  },
  accordionSummary: {
    backgroundColor: "#f5f5f5",
    borderRadius: 4,
    minHeight: 48,
    "&.Mui-expanded": {
      minHeight: 48,
    },
  },
  accordionDetails: {
    flexDirection: "column",
    padding: theme.spacing(2),
  },
  tab: {
    [theme.breakpoints.down("sm")]: {
      minWidth: "auto",
      fontSize: "0.8rem",
    },
  },
  paper: {
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(1),
    },
  },
  container: {
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  mobileAccordion: {
    width: "100%",
    marginBottom: theme.spacing(1),
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    borderRadius: 8,
    "&:before": {
      display: "none",
    },
  },
}));

const SessionSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
});

const WhatsAppModal = ({ open, onClose, whatsAppId, channel }) => {
  const classes = useStyles();
  const [autoToken, setAutoToken] = useState("");

  const inputFileRef = useRef(null);

  const [attachment, setAttachment] = useState(null);
  const [attachmentName, setAttachmentName] = useState("");

  const initialState = {
    name: "",
    greetingMessage: "",
    complationMessage: "",
    outOfHoursMessage: "",
    ratingMessage: "",
    isDefault: false,
    token: "",
    maxUseBotQueues: 3,
    provider: "beta",
    expiresTicket: 0,
    allowGroup: false,
    enableImportMessage: false,
    groupAsTicket: "disabled",
    timeUseBotQueues: "0",
    timeSendQueue: "0",
    sendIdQueue: 0,
    expiresTicketNPS: "0",
    expiresInactiveMessage: "",
    timeInactiveMessage: "",
    inactiveMessage: "",
    maxUseBotQueuesNPS: 3,
    whenExpiresTicket: 0,
    timeCreateNewTicket: 0,
    greetingMediaAttachment: "",
    importRecentMessages: "",
    importOldMessages: "",
    importOldMessagesGroups: "",
    integrationId: "",
    collectiveVacationEnd: "",
    collectiveVacationStart: "",
    collectiveVacationMessage: "",
    queueIdImportMessages: null,
    isOficial: false,
    phone_number_id: "",
    waba_id: "",
    send_token: "",
    business_id: "",
    phone_number: "",
    color: getRandomHexColor(),
    flowInactiveTime: 0,
    flowIdInactiveTime: 0,
    timeAwaitActiveFlowId: 0,
    maxUseInactiveTime: 1,
    timeToReturnQueue: 0,
    triggerIntegrationOnClose: true,
    autoRejectCalls: false,
    autoImportContacts: false,
    autoQueueId: null,
  };
  const [whatsApp, setWhatsApp] = useState(initialState);
  const [selectedQueueIds, setSelectedQueueIds] = useState([]);
  const [queues, setQueues] = useState([]);
  const [tab, setTab] = useState("general");
  const [enableImportMessage, setEnableImportMessage] = useState(false);
  const [importOldMessagesGroups, setImportOldMessagesGroups] = useState(false);
  const [closedTicketsPostImported, setClosedTicketsPostImported] =
    useState(false);
  const [importOldMessages, setImportOldMessages] = useState(
    moment().add(-1, "days").format("YYYY-MM-DDTHH:mm")
  );
  const [importRecentMessages, setImportRecentMessages] = useState(
    moment().add(-1, "minutes").format("YYYY-MM-DDTHH:mm")
  );
  const [copied, setCopied] = useState(false);
  const [integrations, setIntegrations] = useState([]);
  const [schedulesEnabled, setSchedulesEnabled] = useState(false);
  const [NPSEnabled, setNPSEnabled] = useState(false);
  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);
  const { user } = useContext(AuthContext);
  const [isOficial, setIsOficial] = useState(false);
  const [useWhatsappOfficial, setUseWhatsappOfficial] = useState(false);
  const [colorPickerModalOpen, setColorPickerModalOpen] = useState(false);

  const [schedules, setSchedules] = useState([
    {
      weekday: i18n.t("queueModal.serviceHours.monday"),
      weekdayEn: "monday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.tuesday"),
      weekdayEn: "tuesday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.wednesday"),
      weekdayEn: "wednesday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.thursday"),
      weekdayEn: "thursday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.friday"),
      weekdayEn: "friday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: "Sábado",
      weekdayEn: "saturday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: "Domingo",
      weekdayEn: "sunday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
  ]);

  const { get: getSetting } = useCompanySettings();
  const { permissions } = usePlanPermissions();

  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const [triggerIntegrationOnClose, setTriggerIntegrationOnClose] =
    useState(true);
  const [integrationType, setIntegrationType] = useState("n8n");
  const [integrationTypeId, setIntegrationTypeId] = useState(null);

  const [prompts, setPrompts] = useState([]);
  

  const [webhooks, setWebhooks] = useState([]);
  const [flowIdNotPhrase, setFlowIdNotPhrase] = useState();
  const [flowIdWelcome, setFlowIdWelcome] = useState();
  const [flowIdInactiveTime, setFlowIdInactiveTime] = useState();
  const [timeAwaitActiveFlowId, setTimeAwaitActiveFlowId] = useState();

  useEffect(() => {
    // Só gera um novo token se for uma nova conexão (sem whatsAppId) e não tiver token
    if (!whatsAppId && !whatsApp.token) {
      setAutoToken(generateRandomCode(30));
    } else if (whatsApp.token) {
      // Se já existe um token (editando conexão), usa o token existente
      setAutoToken(whatsApp.token);
    }
  }, [whatsAppId, whatsApp.token]);

  useEffect(() => {
    setShowOpenAi(permissions.useOpenAi);
    setShowIntegrations(permissions.useIntegrations);
    setUseWhatsappOfficial(permissions.useWhatsappOfficial);
  }, [permissions.useOpenAi, permissions.useIntegrations, permissions.useWhatsappOfficial]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/prompt");
        setPrompts(data.prompts);
      } catch (err) {
        toastError(err);
      }
    })();
  }, [whatsAppId]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/flowbuilder");
        setWebhooks(data.flows);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const settingSchedules = await getSetting({
        column: "scheduleType",
      });
      setSchedulesEnabled(settingSchedules.scheduleType === "connection");
      const settingNPS = await getSetting({
        column: "userRating",
      });
      setNPSEnabled(settingNPS.userRating === "enabled");
    };
    fetchData();
  }, []);

  const handleEnableImportMessage = async (e) => {
    setEnableImportMessage(e.target.checked);
  };

  const handleEnableIsOficial = async (e) => {
    setIsOficial(e.target.checked);
  };

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;

      try {
        const { data } = await api.get(`whatsapp/${whatsAppId}?session=0`);

        if (data && data?.flowIdNotPhrase) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.flowIdNotPhrase}`
          );
          const selectedFlowIdNotPhrase = flowDefault?.flow.id;
          setFlowIdNotPhrase(selectedFlowIdNotPhrase);
        }

        if (data && data?.flowIdWelcome) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.flowIdWelcome}`
          );
          const selectedFlowIdWelcome = flowDefault?.flow.id;
          setFlowIdWelcome(selectedFlowIdWelcome);
        }

        if (data && data?.flowIdInactiveTime) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.flowIdInactiveTime}`
          );
          const selectedFlowIdInactiveTime = flowDefault?.flow.id;
          setFlowIdInactiveTime(selectedFlowIdInactiveTime);
        }

        if (data && data?.timeAwaitActiveFlowId) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.timeAwaitActiveFlowId}`
          );
          const selectedTimeAwaitActiveFlowId = flowDefault?.flow.id;
          setTimeAwaitActiveFlowId(selectedTimeAwaitActiveFlowId);
        }

        setWhatsApp(data);
        setAttachmentName(data.greetingMediaAttachment);
        setAutoToken(data.token);
        
        data.promptId
          ? setSelectedPrompt(data.promptId)
          : setSelectedPrompt(null);
        const whatsQueueIds = data.queues?.map((queue) => queue.id);
        setSelectedQueueIds(whatsQueueIds);
        // Corrigir a verificação do canal oficial
        setIsOficial(data.channel === "whatsapp_oficial");
        setSchedules(data.schedules);
        if (!isNil(data?.importOldMessages)) {
          setEnableImportMessage(true);
          setImportOldMessages(data?.importOldMessages);
          setImportRecentMessages(data?.importRecentMessages);
          setClosedTicketsPostImported(data?.closedTicketsPostImported);
          setImportOldMessagesGroups(data?.importOldMessagesGroups);
        }
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, [whatsAppId]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/queue");
        setQueues(data);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/queueIntegration");

        setIntegrations(data.queueIntegrations);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  useEffect(() => {
    // Corrigir a verificação do canal oficial
    setIsOficial(channel === "whatsapp_oficial");
  }, [channel]);

  const handleChangeQueue = (e) => {
    setSelectedQueueIds(e);
    setSelectedPrompt(null);
  };

  const handleChangePrompt = (e) => {
    setSelectedPrompt(e.target.value);
    setSelectedQueueIds([]);
  };

  const handleChange = (e) => {
    setTriggerIntegrationOnClose(e.target.value);
  };

  const handleIntegrationTypeChange = (e) => {
    setIntegrationType(e.target.value);
    setIntegrationTypeId(e.target.value);
  };

  const handleSaveWhatsApp = async (values) => {
    if (!whatsAppId) setAutoToken(generateRandomCode(30));

    if (NPSEnabled) {
      if (isNil(values.ratingMessage)) {
        toastError(i18n.t("whatsappModal.errorRatingMessage"));
        return;
      }

      if (
        values.expiresTicketNPS === "0" &&
        values.expiresTicketNPS === "" &&
        values.expiresTicketNPS === 0
      ) {
        toastError(i18n.t("whatsappModal.errorExpiresNPS"));
        return;
      }
    }

    if (values.timeSendQueue === "") values.timeSendQueue = "0";

    if (
      (values.sendIdQueue === 0 ||
        values.sendIdQueue === "" ||
        isNil(values.sendIdQueue)) &&
      values.timeSendQueue !== 0 &&
      values.timeSendQueue !== "0"
    ) {
      toastError(i18n.t("whatsappModal.errorSendQueue"));
      return;
    }

    const whatsappData = {
      ...values,
      flowIdWelcome: flowIdWelcome ? flowIdWelcome : null,
      flowIdInactiveTime: flowIdInactiveTime ? flowIdInactiveTime : null,
      flowIdNotPhrase: flowIdNotPhrase ? flowIdNotPhrase : null,
      timeAwaitActiveFlowId: timeAwaitActiveFlowId
        ? timeAwaitActiveFlowId
        : null,
      queueIds: selectedQueueIds,
      importOldMessages: enableImportMessage ? importOldMessages : null,
      importRecentMessages: enableImportMessage ? importRecentMessages : null,
      importOldMessagesGroups: importOldMessagesGroups
        ? importOldMessagesGroups
        : null,
      closedTicketsPostImported: closedTicketsPostImported
        ? closedTicketsPostImported
        : null,
      token: autoToken ? autoToken : null,
      schedules,
      promptId: selectedPrompt ? selectedPrompt : null,
      channel, // Garantir que o channel está sendo passado corretamente
      triggerIntegrationOnClose: triggerIntegrationOnClose,
      integrationTypeId: triggerIntegrationOnClose ? integrationTypeId : null,
      color: values.color ? values.color : getRandomHexColor(),
    };
    delete whatsappData["queues"];
    delete whatsappData["session"];

    try {
      if (whatsAppId) {
        if (
          whatsAppId &&
          enableImportMessage &&
          whatsApp?.status === "CONNECTED" &&
          whatsApp?.channel === "whatsapp" // Only for regular WhatsApp, not official
        ) {
          try {
            setWhatsApp({ ...whatsApp, status: "qrcode" });
            await api.delete(`/whatsappsession/${whatsApp.id}`);
          } catch (err) {
            toastError(err);
          }
        }

        await api.put(`/whatsapp/${whatsAppId}`, whatsappData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/whatsapp/${whatsAppId}/media-upload`, formData);
        }
        if (!attachmentName && whatsApp.greetingMediaAttachment !== null) {
          await api.delete(`/whatsapp/${whatsAppId}/media-upload`);
        }
      } else {
        const { data } = await api.post("/whatsapp", whatsappData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/whatsapp/${data.id}/media-upload`, formData);
        }
      }
      toast.success(i18n.t("whatsappModal.success"));

      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  function generateRandomCode(length) {
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyvz0123456789";
    let code = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      code += charset.charAt(randomIndex);
    }
    return code;
  }

  const handleRefreshToken = () => {
    setAutoToken(generateRandomCode(30));
  };

  const handleChangeFlowIdNotPhrase = (e) => {
    console.log(e.target.value);
    setFlowIdNotPhrase(e.target.value);
  };

  const handleChangeFlowIdWelcome = (e) => {
    setFlowIdWelcome(e.target.value);
  };

  const handleChangeFlowIdInactiveTime = (e) => {
    setFlowIdInactiveTime(e.target.value);
  };

  const handleChangeTimeAwaitActiveFlowId = (e) => {
    setTimeAwaitActiveFlowId(e.target.value);
  };

  const handleCopyToken = () => {
    navigator.clipboard.writeText(autoToken); // Copia o token para a área de transferência
    setCopied(true); // Define o estado de cópia como verdadeiro
  };

  const handleSaveSchedules = async (values) => {
    toast.success("Clique em salvar para registar as alterações");
    setSchedules(values);
  };

  const handleClose = () => {
    onClose();
    setWhatsApp(initialState);
    setEnableImportMessage(false);
    // inputFileRef.current.value = null
    setAttachment(null);
    setAttachmentName("");
    setCopied(false);
  };

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleFileUpload = () => {
    const file = inputFileRef.current.files[0];
    setAttachment(file);
    setAttachmentName(file.name);
    inputFileRef.current.value = null;
  };

  const handleDeleFile = () => {
    setAttachment(null);
    setAttachmentName(null);
  };

  // Componente para campos de data/hora com melhor responsividade
  const DateTimeField = ({ label, value, onChange, min, max, error, helperText, required }) => (
    <Field
      as={TextField}
      label={label}
      type="datetime-local"
      fullWidth
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={{
        max: max,
        min: min,
      }}
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      variant="outlined"
      margin="dense"
      required={required}
    />
  );

  // Componente para campos de data com melhor responsividade
  const DateField = ({ label, name, min, error, helperText, required }) => (
    <Field
      as={TextField}
      label={label}
      type="date"
      fullWidth
      name={name}
      inputProps={{
        min: min,
      }}
      InputLabelProps={{
        shrink: true,
      }}
      error={error}
      helperText={helperText}
      variant="outlined"
      margin="dense"
      required={required}
    />
  );

  // Componente para campos de texto com melhor responsividade
  const ResponsiveTextField = ({ label, name, multiline, rows, error, helperText, required, type = "text" }) => (
    <Field
      as={TextField}
      label={label}
      type={type}
      fullWidth
      name={name}
      multiline={multiline}
      rows={rows}
      error={error}
      helperText={helperText}
      variant="outlined"
      margin="dense"
      required={required}
    />
  );

  // Componente para selects com melhor responsividade
  const ResponsiveSelect = ({ label, name, children, required }) => (
    <FormControl
      variant="outlined"
      margin="dense"
      fullWidth
    >
      <InputLabel>{label}</InputLabel>
      <Field
        as={Select}
        label={label}
        name={name}
        required={required}
      >
        {children}
      </Field>
    </FormControl>
  );

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        fullScreen={window.innerWidth < 600}
        scroll="paper"
      >
        <DialogTitle>
          {whatsAppId
            ? i18n.t("whatsappModal.title.edit")
            : i18n.t("whatsappModal.title.add")}
        </DialogTitle>
        <Formik
          initialValues={whatsApp}
          enableReinitialize={true}
          validationSchema={SessionSchema}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSaveWhatsApp(values);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ values, touched, errors, isSubmitting }) => (
            <Form>
              <Paper className={classes.paper} elevation={0}>
                <Tabs
                  value={tab}
                  indicatorColor="primary"
                  textColor="primary"
                  scrollButtons="on"
                  variant="scrollable"
                  onChange={handleTabChange}
                  className={classes.tab}
                >
                  <Tab
                    label={i18n.t("whatsappModal.tabs.general")}
                    value={"general"}
                  />
                  <Tab
                    label={i18n.t("whatsappModal.tabs.integrations")}
                    value={"integrations"}
                  />
                  <Tab
                    label={i18n.t("whatsappModal.tabs.messages")}
                    value={"messages"}
                  />
                  <Tab label="Chatbot" value={"chatbot"} />
                  <Tab
                    label={i18n.t("whatsappModal.tabs.assessments")}
                    value={"nps"}
                  />
                  {user.showFlow === "enabled" && (
                    <Tab label="Fluxo Padrão" value={"flowbuilder"} />
                  )}
                  {schedulesEnabled && (
                    <Tab
                      label={i18n.t("whatsappModal.tabs.schedules")}
                      value={"schedules"}
                    />
                  )}
                </Tabs>
              </Paper>
              <Paper className={classes.paper} elevation={0}>
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"general"}
                >
                  <DialogContent dividers>
                    {/* Seção de Upload de Arquivo */}
                    <div style={{ marginBottom: 20 }}>
                      <Typography className={classes.sectionTitle}>
                        {i18n.t("userModal.buttons.addImage")}
                      </Typography>
                      {attachmentName && (
                        <div style={{ marginBottom: 10 }}>
                          <Button
                            variant="outlined"
                            color="secondary"
                            size="small"
                            endIcon={<DeleteOutlineIcon />}
                            onClick={handleDeleFile}
                          >
                            {attachmentName}
                          </Button>
                        </div>
                      )}
                      <input
                        type="file"
                        accept="video/*,image/*"
                        ref={inputFileRef}
                        style={{ display: "none" }}
                        onChange={handleFileUpload}
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => inputFileRef.current.click()}
                        fullWidth
                      >
                        {i18n.t("userModal.buttons.addImage")}
                      </Button>
                    </div>

                    {/* Seção de Informações Básicas */}
                    <Accordion className={classes.mobileAccordion}>
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        className={classes.accordionSummary}
                      >
                        <Typography>Informações Básicas</Typography>
                      </AccordionSummary>
                      <AccordionDetails className={classes.accordionDetails}>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.name")}
                              name="name"
                              error={touched.name && Boolean(errors.name)}
                              helperText={touched.name && errors.name}
                              required
                            />
                          </Grid>
                          
                          <Grid item xs={12} sm={6}>
                            <Field
                              as={TextField}
                              label={i18n.t("connections.table.color")}
                              name="color"
                              id="color"
                              onFocus={() => {
                                setColorPickerModalOpen(false);
                              }}
                              error={touched.color && Boolean(errors.color)}
                              helperText={touched.color && errors.color}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <div
                                      style={{ backgroundColor: values.color }}
                                      className={classes.colorAdorment}
                                    ></div>
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <IconButton
                                    size="small"
                                    color="default"
                                    onClick={() => setColorPickerModalOpen(true)}
                                  >
                                    <Colorize />
                                  </IconButton>
                                ),
                              }}
                              variant="outlined"
                              margin="dense"
                              fullWidth
                            />
                            <ColorPicker
                              open={colorPickerModalOpen}
                              handleClose={() => setColorPickerModalOpen(false)}
                              onChange={(color) => {
                                values.color = color;
                                setWhatsApp(() => {
                                  return { ...values, color };
                                });
                              }}
                            />
                          </Grid>
                          
                          <Grid item xs={12}>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 16 }}>
                              <FormControlLabel
                                control={
                                  <Field
                                    as={Switch}
                                    color="primary"
                                    name="isDefault"
                                    checked={values.isDefault}
                                  />
                                }
                                label={i18n.t("whatsappModal.form.default")}
                              />
                              <FormControlLabel
                                control={
                                  <Field
                                    as={Switch}
                                    color="primary"
                                    name="allowGroup"
                                    checked={values.allowGroup}
                                  />
                                }
                                label={i18n.t("whatsappModal.form.group")}
                              />
                              <FormControlLabel
                                control={
                                  <Field
                                    as={Switch}
                                    color="primary"
                                    name="autoRejectCalls"
                                    checked={values.autoRejectCalls}
                                  />
                                }
                                label="Rejeitar chamadas automaticamente"
                              />
                              <FormControlLabel
                                control={
                                  <Field
                                    as={Switch}
                                    color="primary"
                                    name="autoImportContacts"
                                    checked={values.autoImportContacts}
                                  />
                                }
                                label="Importar contatos automaticamente"
                              />
                              {useWhatsappOfficial &&
                                channel === "whatsapp_oficial" && (
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        size="medium"
                                        checked={isOficial}
                                        onChange={handleEnableIsOficial}
                                        name="isOficial"
                                        color="primary"
                                      />
                                    }
                                    label={i18n.t("whatsappModal.form.isOficial")}
                                  />
                                )}
                            </div>
                          </Grid>
                          
                          <Grid item xs={12}>
                            <ResponsiveSelect
                              label={i18n.t("whatsappModal.form.groupAsTicket")}
                              name="groupAsTicket"
                            >
                              <MenuItem value={"disabled"}>
                                {i18n.t("whatsappModal.menuItem.disabled")}
                              </MenuItem>
                              <MenuItem value={"enabled"}>
                                {i18n.t("whatsappModal.menuItem.enabled")}
                              </MenuItem>
                            </ResponsiveSelect>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    {/* Seção específica para Telegram */}
                    {channel === "telegram" && (
                      <Accordion className={classes.mobileAccordion}>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          className={classes.accordionSummary}
                        >
                          <Typography>Configurações do Telegram</Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordionDetails}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <ResponsiveTextField
                                label="Token do Bot Telegram"
                                name="token"
                                helperText="Obtenha o token com @BotFather no Telegram"
                                required={channel === "telegram"}
                              />
                              <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                                Para criar um bot Telegram:
                                <ol>
                                  <li>Abra o Telegram e procure por @BotFather</li>
                                  <li>Envie o comando /newbot</li>
                                  <li>Siga as instruções e copie o token fornecido</li>
                                </ol>
                              </Typography>
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    )}

                    {/* Seção específica para WhatsApp Oficial */}
                    {isOficial && (
                      <Accordion className={classes.mobileAccordion}>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          className={classes.accordionSummary}
                        >
                          <Typography>Configurações do WhatsApp Oficial</Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordionDetails}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <ResponsiveTextField
                                label={i18n.t("whatsappModal.form.phone_number_id")}
                                name="phone_number_id"
                                error={touched.phone_number_id && Boolean(errors.phone_number_id)}
                                helperText={touched.phone_number_id && errors.phone_number_id}
                                required={isOficial}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <ResponsiveTextField
                                label={i18n.t("whatsappModal.form.waba_id")}
                                name="waba_id"
                                error={touched.waba_id && Boolean(errors.waba_id)}
                                helperText={touched.waba_id && errors.waba_id}
                                required={isOficial}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <ResponsiveTextField
                                label={i18n.t("whatsappModal.form.business_id")}
                                name="business_id"
                                error={touched.business_id && Boolean(errors.business_id)}
                                helperText={touched.business_id && errors.business_id}
                                required={isOficial}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <ResponsiveTextField
                                label={i18n.t("whatsappModal.form.phone_number")}
                                name="phone_number"
                                error={touched.phone_number && Boolean(errors.phone_number)}
                                helperText={touched.phone_number && errors.phone_number}
                                required={isOficial}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <ResponsiveTextField
                                label={i18n.t("whatsappModal.form.send_token")}
                                name="send_token"
                                error={touched.send_token && Boolean(errors.send_token)}
                                helperText={touched.send_token && errors.send_token}
                                required={isOficial}
                              />
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    )}

                    {/* Seção de Importação de Mensagens */}
                    {!isOficial && channel !== "telegram" && (
                      <Accordion className={classes.mobileAccordion}>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          className={classes.accordionSummary}
                        >
                          <Typography>Importação de Mensagens</Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordionDetails}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    size="medium"
                                    checked={enableImportMessage}
                                    onChange={handleEnableImportMessage}
                                    name="importOldMessagesEnable"
                                    color="primary"
                                  />
                                }
                                label={i18n.t("whatsappModal.form.importOldMessagesEnable")}
                              />
                            </Grid>
                            
                            {enableImportMessage && (
                              <>
                                <Grid item xs={12}>
                                  <div style={{ display: "flex", flexWrap: "wrap", gap: 16 }}>
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          size="medium"
                                          checked={importOldMessagesGroups}
                                          onChange={(e) =>
                                            setImportOldMessagesGroups(e.target.checked)
                                          }
                                          name="importOldMessagesGroups"
                                          color="primary"
                                        />
                                      }
                                      label={i18n.t("whatsappModal.form.importOldMessagesGroups")}
                                    />
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          size="medium"
                                          checked={closedTicketsPostImported}
                                          onChange={(e) =>
                                            setClosedTicketsPostImported(e.target.checked)
                                          }
                                          name="closedTicketsPostImported"
                                          color="primary"
                                        />
                                      }
                                      label={i18n.t("whatsappModal.form.closedTicketsPostImported")}
                                    />
                                  </div>
                                </Grid>
                                
                                <Grid item xs={12} sm={6}>
                                  <DateTimeField
                                    label={i18n.t("whatsappModal.form.importOldMessages")}
                                    value={moment(importOldMessages).format("YYYY-MM-DDTHH:mm")}
                                    onChange={(e) => setImportOldMessages(e.target.value)}
                                    max={moment().add(0, "minutes").format("YYYY-MM-DDTHH:mm")}
                                    min={moment().add(-2, "years").format("YYYY-MM-DDTHH:mm")}
                                    error={touched.importOldMessages && Boolean(errors.importOldMessages)}
                                    helperText={touched.importOldMessages && errors.importOldMessages}
                                    required={enableImportMessage}
                                  />
                                </Grid>
                                
                                <Grid item xs={12} sm={6}>
                                  <DateTimeField
                                    label={i18n.t("whatsappModal.form.importRecentMessages")}
                                    value={moment(importRecentMessages).format("YYYY-MM-DDTHH:mm")}
                                    onChange={(e) => setImportRecentMessages(e.target.value)}
                                    max={moment().add(0, "minutes").format("YYYY-MM-DDTHH:mm")}
                                    min={moment(importOldMessages).format("YYYY-MM-DDTHH:mm")}
                                    error={touched.importRecentMessages && Boolean(errors.importRecentMessages)}
                                    helperText={touched.importRecentMessages && errors.importRecentMessages}
                                    required={enableImportMessage}
                                  />
                                </Grid>
                                
                                <Grid item xs={12}>
                                  <ResponsiveSelect
                                    label={i18n.t("whatsappModal.form.queueIdImportMessages")}
                                    name="queueIdImportMessages"
                                    required={enableImportMessage}
                                  >
                                    <MenuItem value={0}>&nbsp;</MenuItem>
                                    {queues.map((queue) => (
                                      <MenuItem key={queue.id} value={queue.id}>
                                        {queue.name}
                                      </MenuItem>
                                    ))}
                                  </ResponsiveSelect>
                                </Grid>
                              </>
                            )}
                          </Grid>
                          
                          {enableImportMessage && (
                            <Typography variant="body2" style={{ color: "red", marginTop: 10 }}>
                              {i18n.t("whatsappModal.form.importAlert")}
                            </Typography>
                          )}
                        </AccordionDetails>
                      </Accordion>
                    )}

                    {/* Seção de Token */}
                    {channel !== "telegram" && (
                      <Accordion className={classes.mobileAccordion}>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          className={classes.accordionSummary}
                        >
                          <Typography>Token de Conexão</Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordionDetails}>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={8}>
                              <TextField
                                label={i18n.t("whatsappModal.form.token")}
                                type="text"
                                fullWidth
                                value={autoToken}
                                variant="outlined"
                                margin="dense"
                                disabled
                              />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                              <Button
                                onClick={handleRefreshToken}
                                disabled={isSubmitting}
                                className={classes.tokenRefresh}
                                variant="outlined"
                                fullWidth
                                startIcon={<Autorenew />}
                              >
                                {window.innerWidth < 600 ? "" : "Gerar"}
                              </Button>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                              <Button
                                onClick={handleCopyToken}
                                className={classes.tokenRefresh}
                                variant="outlined"
                                fullWidth
                                startIcon={<FileCopy style={{ color: copied ? "blue" : "inherit" }} />}
                              >
                                {window.innerWidth < 600 ? "" : "Copiar"}
                              </Button>
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    )}

                    {/* Seção de Redirecionamento de Fila */}
                    <Accordion className={classes.mobileAccordion}>
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        className={classes.accordionSummary}
                      >
                        <Typography>{i18n.t("whatsappModal.form.queueRedirection")}</Typography>
                      </AccordionSummary>
                      <AccordionDetails className={classes.accordionDetails}>
                        <Typography variant="body2" style={{ marginBottom: 15 }}>
                          {i18n.t("whatsappModal.form.queueRedirectionDesc")}
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <ResponsiveSelect
                              label="Fila Automática"
                              name="autoQueueId"
                            >
                              <MenuItem value={null}>Nenhuma</MenuItem>
                              {queues.map((queue) => (
                                <MenuItem key={queue.id} value={queue.id}>
                                  {queue.name}
                                </MenuItem>
                              ))}
                            </ResponsiveSelect>
                            <Typography variant="caption" color="textSecondary" style={{ marginTop: 8, display: 'block' }}>
                              Esta fila será atribuída automaticamente a todos os atendimentos iniciados ou reabertos nesta conexão (apenas para WhatsApp Baileys)
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ResponsiveSelect
                              label={i18n.t("whatsappModal.form.sendIdQueue")}
                              name="sendIdQueue"
                              required={values.timeSendQueue > 0}
                            >
                              <MenuItem value={0}>&nbsp;</MenuItem>
                              {queues.map((queue) => (
                                <MenuItem key={queue.id} value={queue.id}>
                                  {queue.name}
                                </MenuItem>
                              ))}
                            </ResponsiveSelect>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.timeSendQueue")}
                              name="timeSendQueue"
                              error={touched.timeSendQueue && Boolean(errors.timeSendQueue)}
                              helperText={touched.timeSendQueue && errors.timeSendQueue}
                            />
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </DialogContent>
                </TabPanel>
                
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"integrations"}
                >
                  <DialogContent dividers>
                    <Accordion className={classes.mobileAccordion}>
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        className={classes.accordionSummary}
                      >
                        <Typography>Configurações de Integração</Typography>
                      </AccordionSummary>
                      <AccordionDetails className={classes.accordionDetails}>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <QueueSelect
                              selectedQueueIds={selectedQueueIds}
                              onChange={(selectedIds) => handleChangeQueue(selectedIds)}
                            />
                          </Grid>
                          
                          {showIntegrations && (
                            <Grid item xs={12}>
                              <ResponsiveSelect
                                label={i18n.t("queueModal.form.integrationId")}
                                name="integrationId"
                              >
                                <MenuItem value={null}>{"Desabilitado"}</MenuItem>
                                {integrations.map((integration) => (
                                  <MenuItem key={integration.id} value={integration.id}>
                                    {integration.name}
                                  </MenuItem>
                                ))}
                              </ResponsiveSelect>
                            </Grid>
                          )}
                          
                          {showOpenAi && (
                            <>
                              <Grid item xs={12}>
                                <FormControl margin="dense" variant="outlined" fullWidth>
                                  <InputLabel>
                                    {i18n.t("whatsappModal.form.prompt")}
                                  </InputLabel>
                                  <Select
                                    labelId="dialog-select-prompt-label"
                                    id="dialog-select-prompt"
                                    name="promptId"
                                    value={selectedPrompt || ""}
                                    onChange={handleChangePrompt}
                                    label={i18n.t("whatsappModal.form.prompt")}
                                    fullWidth
                                    MenuProps={{
                                      anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left",
                                      },
                                      transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left",
                                      },
                                      getContentAnchorEl: null,
                                    }}
                                  >
                                    {prompts.map((prompt) => (
                                      <MenuItem key={prompt.id} value={prompt.id}>
                                        {prompt.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                                <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                                  {i18n.t("whatsappModal.form.promptHelp")}
                                </Typography>
                              </Grid>
                            </>
                          )}
                          
                          <Grid item xs={12}>
                            <FormControl variant="outlined" margin="dense" fullWidth>
                              <InputLabel>{i18n.t("whatsappModal.form.triggerIntegrationOnClose")}</InputLabel>
                              <Select
                                label={i18n.t("whatsappModal.form.triggerIntegrationOnClose")}
                                value={triggerIntegrationOnClose}
                                onChange={handleChange}
                              >
                                <MenuItem value={false}>
                                  {i18n.t("whatsappModal.menuItem.disabled")}
                                </MenuItem>
                                <MenuItem value={true}>
                                  {i18n.t("whatsappModal.menuItem.enabled")}
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          
                          {triggerIntegrationOnClose && (
                            <Grid item xs={12}>
                              <FormControl variant="outlined" margin="dense" fullWidth>
                                <InputLabel>{i18n.t("queueModal.form.integrationId")}</InputLabel>
                                <Select
                                  label={i18n.t("queueModal.form.integrationId")}
                                  value={integrationTypeId || ""}
                                  onChange={handleIntegrationTypeChange}
                                >
                                  <MenuItem value={null}>{"Desabilitado"}</MenuItem>
                                  {integrations
                                    .filter(
                                      (integration) =>
                                        integration.type === "n8n" ||
                                        integration.type === "typebot"
                                    )
                                    .map((integration) => (
                                      <MenuItem key={integration.id} value={integration.id}>
                                        {integration.name}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormControl>
                            </Grid>
                          )}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </DialogContent>
                </TabPanel>
                
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"messages"}
                >
                  <DialogContent dividers>
                    <Accordion className={classes.mobileAccordion}>
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        className={classes.accordionSummary}
                      >
                        <Typography>Mensagens Automáticas</Typography>
                      </AccordionSummary>
                      <AccordionDetails className={classes.accordionDetails}>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.greetingMessage")}
                              name="greetingMessage"
                              multiline
                              rows={3}
                              error={touched.greetingMessage && Boolean(errors.greetingMessage)}
                              helperText={touched.greetingMessage && errors.greetingMessage}
                            />
                          </Grid>
                          
                          <Grid item xs={12}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.complationMessage")}
                              name="complationMessage"
                              multiline
                              rows={3}
                              error={touched.complationMessage && Boolean(errors.complationMessage)}
                              helperText={touched.complationMessage && errors.complationMessage}
                            />
                          </Grid>
                          
                          <Grid item xs={12}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.outOfHoursMessage")}
                              name="outOfHoursMessage"
                              multiline
                              rows={3}
                              error={touched.outOfHoursMessage && Boolean(errors.outOfHoursMessage)}
                              helperText={touched.outOfHoursMessage && errors.outOfHoursMessage}
                            />
                          </Grid>
                          
                          <Grid item xs={12}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.collectiveVacationMessage")}
                              name="collectiveVacationMessage"
                              multiline
                              rows={3}
                              error={touched.collectiveVacationMessage && Boolean(errors.collectiveVacationMessage)}
                              helperText={touched.collectiveVacationMessage && errors.collectiveVacationMessage}
                            />
                          </Grid>
                          
                          <Grid item xs={12} sm={6}>
                            <DateField
                              label={i18n.t("whatsappModal.form.collectiveVacationStart")}
                              name="collectiveVacationStart"
                              min={moment().add(-10, "days").format("YYYY-MM-DD")}
                              error={touched.collectiveVacationStart && Boolean(errors.collectiveVacationStart)}
                              helperText={touched.collectiveVacationStart && errors.collectiveVacationStart}
                              required={values.collectiveVacationMessage?.length > 0}
                            />
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <DateField
                              label={i18n.t("whatsappModal.form.collectiveVacationEnd")}
                              name="collectiveVacationEnd"
                              min={moment().add(-10, "days").format("YYYY-MM-DD")}
                              error={touched.collectiveVacationEnd && Boolean(errors.collectiveVacationEnd)}
                              helperText={touched.collectiveVacationEnd && errors.collectiveVacationEnd}
                              required={values.collectiveVacationMessage?.length > 0}
                            />
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </DialogContent>
                </TabPanel>
                
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"chatbot"}
                >
                  <DialogContent dividers>
                    <Accordion className={classes.mobileAccordion}>
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        className={classes.accordionSummary}
                      >
                        <Typography>Configurações do Chatbot</Typography>
                      </AccordionSummary>
                      <AccordionDetails className={classes.accordionDetails}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.timeCreateNewTicket")}
                              name="timeCreateNewTicket"
                              error={touched.timeCreateNewTicket && Boolean(errors.timeCreateNewTicket)}
                              helperText={touched.timeCreateNewTicket && errors.timeCreateNewTicket}
                            />
                          </Grid>
                          
                          <Grid item xs={12} sm={6}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.maxUseBotQueues")}
                              name="maxUseBotQueues"
                              error={touched.maxUseBotQueues && Boolean(errors.maxUseBotQueues)}
                              helperText={touched.maxUseBotQueues && errors.maxUseBotQueues}
                            />
                          </Grid>
                          
                          <Grid item xs={12} sm={6}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.timeUseBotQueues")}
                              name="timeUseBotQueues"
                              error={touched.timeUseBotQueues && Boolean(errors.timeUseBotQueues)}
                              helperText={touched.timeUseBotQueues && errors.timeUseBotQueues}
                            />
                          </Grid>
                          
                          <Grid item xs={12} sm={6}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.timeToReturnQueue")}
                              name="timeToReturnQueue"
                              error={touched.timeToReturnQueue && Boolean(errors.timeToReturnQueue)}
                              helperText={touched.timeToReturnQueue && errors.timeToReturnQueue}
                            />
                          </Grid>
                          
                          <Grid item xs={12} sm={6}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.expiresTicket")}
                              name="expiresTicket"
                              required={values.timeInactiveMessage > 0}
                              error={touched.expiresTicket && Boolean(errors.expiresTicket)}
                              helperText={touched.expiresTicket && errors.expiresTicket}
                            />
                          </Grid>
                          
                          <Grid item xs={12} sm={6}>
                            <ResponsiveSelect
                              label={i18n.t("whatsappModal.form.whenExpiresTicket")}
                              name="whenExpiresTicket"
                            >
                              <MenuItem value={"0"}>
                                {i18n.t("whatsappModal.form.closeLastMessageOptions1")}
                              </MenuItem>
                              <MenuItem value={"1"}>
                                {i18n.t("whatsappModal.form.closeLastMessageOptions2")}
                              </MenuItem>
                            </ResponsiveSelect>
                          </Grid>
                          
                          <Grid item xs={12}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.expiresInactiveMessage")}
                              name="expiresInactiveMessage"
                              multiline
                              rows={3}
                              error={touched.expiresInactiveMessage && Boolean(errors.expiresInactiveMessage)}
                              helperText={touched.expiresInactiveMessage && errors.expiresInactiveMessage}
                            />
                          </Grid>
                          
                          <Grid item xs={12}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.timeInactiveMessage")}
                              name="timeInactiveMessage"
                              error={touched.timeInactiveMessage && Boolean(errors.timeInactiveMessage)}
                              helperText={touched.timeInactiveMessage && errors.timeInactiveMessage}
                            />
                          </Grid>
                          
                          <Grid item xs={12}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.inactiveMessage")}
                              name="inactiveMessage"
                              multiline
                              rows={3}
                              error={touched.inactiveMessage && Boolean(errors.inactiveMessage)}
                              helperText={touched.inactiveMessage && errors.inactiveMessage}
                            />
                          </Grid>
                          
                          {user.showFlow === "enabled" && (
                            <>
                              <Grid item xs={12} sm={4}>
                                <ResponsiveTextField
                                  label={i18n.t("whatsappModal.form.flowInactiveTime")}
                                  name="flowInactiveTime"
                                  error={touched.flowIdInactiveTime && Boolean(errors.flowIdInactiveTime)}
                                  helperText={touched.flowIdInactiveTime && errors.flowIdInactiveTime}
                                />
                              </Grid>
                              
                              <Grid item xs={12} sm={4}>
                                <ResponsiveTextField
                                  label={i18n.t("whatsappModal.form.maxUseInactiveTime")}
                                  name="maxUseInactiveTime"
                                  error={touched.maxUseInactiveTime && Boolean(errors.maxUseInactiveTime)}
                                  helperText={touched.maxUseInactiveTime && errors.maxUseInactiveTime}
                                />
                              </Grid>
                              
                              <Grid item xs={12} sm={4}>
                                <FormControl variant="outlined" margin="dense" fullWidth>
                                  <InputLabel>Fluxo de Inatividade</InputLabel>
                                  <Select
                                    label="Fluxo de Inatividade"
                                    value={flowIdInactiveTime || ""}
                                    onChange={handleChangeFlowIdInactiveTime}
                                  >
                                    <MenuItem value={null}>{"Desabilitado"}</MenuItem>
                                    {webhooks.map((webhook) => (
                                      <MenuItem key={webhook.id} value={webhook.id}>
                                        {webhook.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>
                            </>
                          )}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </DialogContent>
                </TabPanel>
                
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"nps"}
                >
                  <DialogContent dividers>
                    <Accordion className={classes.mobileAccordion}>
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        className={classes.accordionSummary}
                      >
                        <Typography>Avaliação e NPS</Typography>
                      </AccordionSummary>
                      <AccordionDetails className={classes.accordionDetails}>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.ratingMessage")}
                              name="ratingMessage"
                              multiline
                              rows={3}
                              error={touched.ratingMessage && Boolean(errors.ratingMessage)}
                              helperText={touched.ratingMessage && errors.ratingMessage}
                            />
                          </Grid>
                          
                          <Grid item xs={12} sm={6}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.maxUseBotQueuesNPS")}
                              name="maxUseBotQueuesNPS"
                              error={touched.maxUseBotQueuesNPS && Boolean(errors.maxUseBotQueuesNPS)}
                              helperText={touched.maxUseBotQueuesNPS && errors.maxUseBotQueuesNPS}
                            />
                          </Grid>
                          
                          <Grid item xs={12} sm={6}>
                            <ResponsiveTextField
                              label={i18n.t("whatsappModal.form.expiresTicketNPS")}
                              name="expiresTicketNPS"
                              error={touched.expiresTicketNPS && Boolean(errors.expiresTicketNPS)}
                              helperText={touched.expiresTicketNPS && errors.expiresTicketNPS}
                            />
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </DialogContent>
                </TabPanel>
                
                {showIntegrations && user.showFlow === "enabled" && (
                  <TabPanel
                    className={classes.container}
                    value={tab}
                    name={"flowbuilder"}
                  >
                    <DialogContent dividers>
                      <Accordion className={classes.mobileAccordion}>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          className={classes.accordionSummary}
                        >
                          <Typography>Fluxo de Boas Vindas</Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordionDetails}>
                          <Typography variant="body2" style={{ marginBottom: 15 }}>
                            Este fluxo é disparado apenas para novos contatos,
                            pessoas que você não possui em sua lista de contatos e
                            que mandaram uma mensagem
                          </Typography>
                          <FormControl variant="outlined" margin="dense" fullWidth>
                            <InputLabel>Fluxo de Boas Vindas</InputLabel>
                            <Select
                              label="Fluxo de Boas Vindas"
                              value={flowIdWelcome || ""}
                              onChange={handleChangeFlowIdWelcome}
                            >
                              <MenuItem value={null}>{"Desabilitado"}</MenuItem>
                              {webhooks.map((webhook) => (
                                <MenuItem key={webhook.id} value={webhook.id}>
                                  {webhook.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </AccordionDetails>
                      </Accordion>
                      
                      <Accordion className={classes.mobileAccordion}>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          className={classes.accordionSummary}
                        >
                          <Typography>Fluxo de Resposta Padrão</Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordionDetails}>
                          <Typography variant="body2" style={{ marginBottom: 15 }}>
                            Resposta Padrão é enviada com qualquer caractere
                            diferente de uma palavra chave. ATENÇÃO! Será
                            disparada se o atendimento já estiver fechado.
                          </Typography>
                          <FormControl variant="outlined" margin="dense" fullWidth>
                            <InputLabel>Fluxo de Resposta Padrão</InputLabel>
                            <Select
                              label="Fluxo de Resposta Padrão"
                              value={flowIdNotPhrase || ""}
                              onChange={handleChangeFlowIdNotPhrase}
                            >
                              <MenuItem value={null}>{"Desabilitado"}</MenuItem>
                              {webhooks.map((webhook) => (
                                <MenuItem key={webhook.id} value={webhook.id}>
                                  {webhook.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </AccordionDetails>
                      </Accordion>
                    </DialogContent>
                  </TabPanel>
                )}
                
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"schedules"}
                >
                  {tab === "schedules" && (
                    <Paper style={{ padding: 20 }}>
                      <SchedulesForm
                        loading={false}
                        onSubmit={handleSaveSchedules}
                        initialValues={schedules}
                        labelSaveButton={i18n.t("whatsappModal.buttons.okAdd")}
                      />
                    </Paper>
                  )}
                </TabPanel>
              </Paper>
              
              <DialogActions>
                <Button
                  onClick={handleClose}
                  color="secondary"
                  disabled={isSubmitting}
                  variant="outlined"
                >
                  {i18n.t("whatsappModal.buttons.cancel")}
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  disabled={isSubmitting}
                  variant="contained"
                  className={classes.btnWrapper}
                >
                  {whatsAppId
                    ? i18n.t("whatsappModal.buttons.okEdit")
                    : i18n.t("whatsappModal.buttons.okAdd")}
                  {isSubmitting && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div>
  );
};

export default React.memo(WhatsAppModal);